<div class="h-100 color-dark">
  <div class="flex-column gap-5 h-100">
    <button
      pButton
      type="button"
      class="p-button p-button-primary p-button-outlined medium icon-only close-button"
      [routerLink]="['/', paths.AUTH, paths.auth.LOGIN]"
      [activityLogClick]="AnalyticClickEventNames.landing.BACK_TO_LOGIN">
      <shared-icon icon="alt-arrow-left" height="1rem" width="1rem" class="fill-dark" />
    </button>

    <div class="text-28 bold-800 text-center color-dark">
      Welcome to your <br />
      Mortgage Monitor
    </div>
    <div class="text-16 text-center">
      Click the link we’ve sent you to
      <b>{{ email }}</b>
    </div>
    <form [formGroup]="verificationCodeForm" class="form-wrapper flex-column gap-4 border-radius-3 bg-light p-4">
      <div class="flex-column align-items-center gap-3">
        @if (isSendingVerificationCodeSlowly()) {
          <div class="text-12 text-center">
            Sending verification code to <span class="bold">{{ email }}</span
            >…
          </div>
        } @else {
          <div class="text-12 text-center">
            Opening the email from a different device?
            <br />
            Enter <b>the verification code</b> from the email
          </div>
        }

        <div
          class="flex-column center-mask relative verification-code-input"
          [class.verification-code-input-error]="isIncorrectCodeError$ | async">
          <p-inputmask
            mask="999999"
            formControlName="verificationCode"
            placeholder="______"
            [styleClass]="(isIncorrectCodeError$ | async) ? 'w-100 color-red' : 'w-100'" />
          @if (isLoadingSignInCompanies$ | async) {
            <p-progressSpinner class="primary-color absolute verification-code-spinner" ariaLabel="Checking code" />
          }
        </div>

        @if ((isIncorrectCodeError$ | async) || (authError$ | async)) {
          <cp-sign-in-code-error
            [isIncorrectCode]="!!(isIncorrectCodeError$ | async)"
            [hasError]="!!(authError$ | async)"
            incorrectCodeHint="Use the code from the most recent email — older codes stop working once a new one is sent." />
        } @else if (isNewCodeSent$ | async) {
          <div class="flex align-items-center justify-content-center gap-1 text-12 bold color-dark">
            <shared-icon icon="plain" fill="var(--color-green)" height="1rem" width="1rem" />
            New code sent.
          </div>
        }
      </div>

      @if (timeLeftTillResendEnabled()) {
        <div class="text-12 text-center">
          Nothing in your inbox? Check spam.
          <br />
          You can resend new code in <b>{{ timeLeftTillResendEnabled() }}s</b>
        </div>
      } @else {
        <button
          pButton
          type="button"
          class="p-button-primary p-button-outlined centered w-100"
          [loading]="isSendingVerificationCode()"
          [disabled]="isSendingVerificationCode()"
          [activityLogClick]="AnalyticClickEventNames.landing.RESEND_CODE"
          (click)="resendCode()">
          Resend new code
        </button>
      }
    </form>
    <button
      pButton
      type="button"
      class="p-button-text primary centered align-self-center mt-auto"
      [routerLink]="['/', paths.AUTH, paths.auth.LOGIN]">
      Go to login page
    </button>
  </div>
</div>
